import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import { Button } from 'ck-ui';
import classnames from 'classnames';
import styles from './ClearRefinements.module.scss';

const ClearRefinements = connectCurrentRefinements(({ items, refine, toggleMobileAside }) => {
  const filterCount = items.reduce((sum, item) => {
    // Do not include inStock default refinement
    if (item.attribute === 'inStock') {
      return sum;
    }
    const refinedCount = Array.isArray(item.currentRefinement) ? item.currentRefinement.length : 1;
    return sum + refinedCount;
  }, 0);

  const clearAll = () => {
    refine(items);
  };

  return (
    <div className={styles.root}>
      <div className={classnames(styles.btnContainer, styles.firstBtn)}>
        <Button fullwidth="mobile" className={styles.btnText} secondary onClick={clearAll}>
          CLEAR ALL
        </Button>
      </div>

      <div className={styles.btnContainer}>
        <Button fullwidth="mobile" className={styles.btnText} onClick={toggleMobileAside}>
          APPLY({filterCount})
        </Button>
      </div>

    </div>
  );
});

export { ClearRefinements };
